const LIST_CONTACTS_SUCCESS = "LIST_CONTACTS_SUCCESS";
const LIST_CONTACTS_FAILURE = "LIST_CONTACTS_FAILURE";

export { LIST_CONTACTS_SUCCESS, LIST_CONTACTS_FAILURE };
